import React from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { DASHBOARD, SOCIETY_BRAND, SOCIETY_BRAND_CREATE, SOCIETY_CONTROLLER } from "../../../Routing/routes";
import FormValidationLayer from "./Component/FormValidationLayer";

const CreateBrand = () => {
    const links = [{ to: SOCIETY_BRAND, text: 'Community Brand' }, { to: SOCIETY_BRAND_CREATE, text: 'Create' }]
    return (
        <>
            <Breadcrumb replaceClass="mb-24" links={links} headingTitle="Create Community Brand" title="CRM" to={SOCIETY_CONTROLLER + DASHBOARD} />
            <FormValidationLayer />
        </>
    );
};

export default CreateBrand;
